export default "__VITE_ASSET__B37goGhI__"